<div *ngIf="showBanner" class="cookie-container" [@popInAndOut]>
  <div class="cookie-content">
    <div class="cookie-text">
      We use cookies to ensure that we give you the best experience on our website. By accepting we'll assume that you are happy to receive all cookies on our
      website. However, if you would like to, you can change your cookie settings at any time.
      <a target="_blank" class="cta-subtext" [href]="termsUrl">Read More</a>
    </div>

    <div class="cookie-cta">
      <dn-marketing-btn text="Got it!" [marketBtnSize]="buttonSizes.Marketing" (clickButton)="onGotItButtonClick()"></dn-marketing-btn>
      <a target="_blank" class="cta-subtext" [href]="termsUrl">Read More</a>
    </div>
  </div>
</div>
